<template>
  <symbol
    id="angle-right"
    viewBox="0 0 192 322"
  >
    <path
      d="M187.8 169.5L41 317.5C36.3 322.2 28.7 322.2 24 317.5L4.20005 297.7C-0.499951 293 -0.499951 285.4 4.20005 280.7L122.7 161L4.20005 41.3C-0.499951 36.6 -0.499951 29 4.20005 24.3L24 4.49998C28.7 -0.200024 36.3 -0.200024 41 4.49998L187.8 152.5C192.5 157.2 192.5 164.8 187.8 169.5Z"
    />
  </symbol>
</template>
